import { render } from "./Product_edit.vue?vue&type=template&id=7c0d52ba&scoped=true"
import script from "./Product_edit.vue?vue&type=script&lang=js"
export * from "./Product_edit.vue?vue&type=script&lang=js"

import "./Product_edit.vue?vue&type=style&index=0&id=7c0d52ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0d52ba"]])

export default __exports__